module.exports = __webpack_public_path__ + "img/tuvsudlogo.6b9a19b8.png";